export const timezones = [
  // 🇧🇷 Fusos do Brasil

  { zona: "Brasília (BRT - UTC-3)", query: "America/Sao_Paulo" },
  { zona: "Acre (ACT - UTC-5)", query: "America/Rio_Branco" },
  { zona: "Amazonas (AMT - UTC-4)", query: "America/Manaus" },
  { zona: "Mato Grosso (AMT - UTC-4)", query: "America/Cuiaba" },
  {
    zona: "Fernando de Noronha (FNT - UTC-2)",
    query: "America/Noronha",
  },

  // 🌍 Fusos internacionais
  { zona: "Padrão do Leste (EST - UTC-5)", query: "America/New_York" },
  {
    zona: "Padrão do Pacífico (PST - UTC-8)",
    query: "America/Los_Angeles",
  },
  { zona: "Londres (GMT - UTC+1)", query: "Europe/London" },
  { zona: "Europa Central (CET - UTC+1)", query: "Europe/Berlin" },
  { zona: "Moscou (MSK - UTC+3)", query: "Europe/Moscow" },
  { zona: "Tóquio (JST - UTC+9)", query: "Asia/Tokyo" },
  { zona: "Padrão da Índia (IST - UTC+5:30)", query: "Asia/Kolkata" },
  { zona: "Austrália (AEST - UTC+10)", query: "Australia/Sydney" },
  { zona: "Alasca (AKST - UTC-9)", query: "America/Anchorage" },
  { zona: "Havaí (HST - UTC-10)", query: "Pacific/Honolulu" },
  { zona: "Pequim (CST - UTC+8)", query: "Asia/Shanghai" },
  { zona: "Dubai (GST - UTC+4)", query: "Asia/Dubai" },
  { zona: "Bangkok (ICT - UTC+7)", query: "Asia/Bangkok" },
  {
    zona: "Cidade do Cabo (SAST - UTC+2)",
    query: "Africa/Johannesburg",
  },
  {
    zona: "Buenos Aires (ART - UTC-3)",
    query: "America/Argentina/Buenos_Aires",
  },
  { zona: "Vancouver (PST - UTC-8)", query: "America/Vancouver" },
  { zona: "Madri (CET - UTC+1)", query: "Europe/Madrid" },
  { zona: "Roma (CET - UTC+1)", query: "Europe/Rome" },
  { zona: "Istambul (TRT - UTC+3)", query: "Europe/Istanbul" },
  { zona: "Cairo (EET - UTC+2)", query: "Africa/Cairo" },
  { zona: "Seul (KST - UTC+9)", query: "Asia/Seoul" },
  { zona: "Manila (PHT - UTC+8)", query: "Asia/Manila" },
];
